import { render, staticRenderFns } from "./FindWordsAnswerOption.vue?vue&type=template&id=18105bac&scoped=true"
import script from "./FindWordsAnswerOption.vue?vue&type=script&lang=ts"
export * from "./FindWordsAnswerOption.vue?vue&type=script&lang=ts"
import style0 from "./FindWordsAnswerOption.vue?vue&type=style&index=0&id=18105bac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18105bac",
  null
  
)

export default component.exports